import React from 'react';
import logoFull from '../../../assets/images/logo-full.png';
import PublicPrivacyFooter from '../../../components/publicPageFooter/PublicPrivacyFooter';

/**
 * TrustFooter
 * Rodapé minimalista "Agendamento online por Gabriela" + link para a
 * Política de Privacidade (LGPD), exibido em toda página pública que usa
 * este rodapé (agenda online e confirmação de agendamento).
 */
export default function TrustFooter() {
    return (
        <>
            <footer className="ps-footer">
                <span className="ps-footer__text">Agendamento online por</span>
                <a
                    href="https://www.gabriela.app.br"
                    target="_blank"
                    rel="noreferrer"
                    className="ps-footer__link"
                >
                    <img src={logoFull} alt="Gabriela" className="ps-footer__logo" />
                </a>
            </footer>
            <PublicPrivacyFooter />
        </>
    );
}
